import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

export const ExpectedShipDate = ({ shipDate }: { shipDate?: string }) => {
  if (!shipDate) {
    return null;
  }
  return (
    <>
      <Typography
        variant="paragraphSansRegular"
        data-test-id="expected-ship-range"
      >
        {shipDate}
      </Typography>
      <Spacer height={5} />
    </>
  );
};
